import React, {createContext, useContext, useMemo, useState} from 'react';
import {useChartConfig} from './ChartConfigContext';

const StatisticsUIContext = createContext();

export const StatisticsUIProvider = ({children}) => {
  const [activeTab, setActiveTab] = useState('SmartPi');
  const {chartsConfig} = useChartConfig();
  const activeGroup = chartsConfig?.groups?.find((g) => g.name === activeTab);

  const value = useMemo(() => ({
    activeTab,
    setActiveTab,
    activeGroup,
  }), [activeTab, activeGroup]);

  return <StatisticsUIContext.Provider value={value}>{children}</StatisticsUIContext.Provider>;
};

export const useStatisticsUI = () => {
  const context = useContext(StatisticsUIContext);
  if (!context) {
    throw new Error('useStatisticsUI must be used within StatisticsUIProvider');
  }
  return context;
};
